<div class="container">
  <pinch-zoom #pinch [limit-zoom]="8" [wheel]="true" backgroundColor="rgba(0,0,0,0.0)" (events)="handleEvent(pinch.pinchZoom.scale)">
    <img class="zoomable-image" [src]="this.image">
  </pinch-zoom>
</div>
